import * as Y from "yjs";
import {yCustomNodeDatas, ydoc} from "@/shared/config/yjs-config.ts";
import { YJS_TASK_LIFECYCLE_ORIGIN } from "@/shared/lib/yjs/transaction-origin";
import { addPendingRun } from "./task-store";

export function handleSubmitSucceed(nodeId: string, runId: string) {
    const yNodeMap = yCustomNodeDatas.get(nodeId) as Y.Map<unknown> | undefined;
    if (yNodeMap) {
        ydoc.transact(() => {
            yNodeMap.set('runId', runId);
            yNodeMap.set('taskId', '');
            yNodeMap.set('status', 'pending');
            yNodeMap.set('progress', 0);
        }, YJS_TASK_LIFECYCLE_ORIGIN);
    }
    addPendingRun(nodeId, runId);
}

